// extracted by mini-css-extract-plugin
export default {"closeModal":"styles_closeModal__kiuvW","header":"styles_header__qwNVh","buttons":"styles_buttons__lu2oU"};